import { SvgIcon } from '@mui/material';

export function IndeterminateIcon() {
  return (
    <SvgIcon width="12" height="2" viewBox="0 0 12 2" fill="none">
      <path d="M11.25 2H0.75C0.3 2 0 1.6 0 1C0 0.4 0.3 0 0.75 0H11.25C11.7 0 12 0.4 12 1C12 1.6 11.625 2 11.25 2Z" />
    </SvgIcon>
  );
}
